import { lazy } from 'react';
export const CoursesRoutes = [
    {//course details in profile section
        path: '/community/course/:courseId',
        component: lazy(() => import('../../views/community/tab/Profile/Courses/courseDetails/CoursesDetail'))
    },
];